import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

import css from './TransitionWrapper.module.css';

export const TransitionWrapper: React.FC<{}> = ({ children }) => {
  const transitionName = {
    enter: css.enter,
    enterActive: css.enterActive,
    leave: css.leave,
    leaveActive: css.leaveActive,
  };
  return (
    <CSSTransitionGroup
      transitionName={transitionName}
      transitionEnterTimeout={600}
      transitionLeaveTimeout={600}
    >
      {children}
    </CSSTransitionGroup>
  );
};
